import { ExclamationCircleOutlined, MailOutlined } from "@ant-design/icons";
import {
  Drawer,
  Tabs,
  Collapse,
  Row,
  Col,
  Form,
  Button as AntdButton,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import styles from "./ProfileDrawer.module.scss";
import moment from "moment-timezone";
import FilesTab from "./FilesTab";
import IntakeForms from "containers/IntakeForms/IntakeForms";
import ChartsTab from "./ChartsTab";
import {
  FormDatePicker,
  FormHiddenSubmitButton,
  FormInput,
  FormPhoneNumber,
} from "components/FormItems/FlatFormItems";
import { Button } from "components/Buttons/Buttons";
import {
  sendWelcomeEmail,
  updateGuest,
  getCustomerPaymentMethods,
  getCustomerWallets,
  getCustomerLoyaltyTransactions,
} from "services/guests.services";
import { useDispatch } from "react-redux";
import AddressesInformation from "components/AddressesInformation/AddressesInformation";
import AppointmentsTab from "./AppointmentsTab";
import CustomerBookingCounts from "components/CustomerBookingCounts/CustomerBookingCounts";
import NotesGrid from "components/NotesGrid/NotesGrid";
import ProgramsList from "components/ProgramsList/ProgramsList";
import GiftCardRow from "components/GiftCardRow/GiftCardRow";
import LoyaltyPointsList from "components/LoyaltyPointsList/LoyaltyPointsList";
import { getCustomerGiftCards } from "services/giftCards.service";
import { setAppointmentDrawer } from "redux/actions/drawer.actions";
import { setSelectedGuest } from "redux/actions/scheduler.actions";
import PaymentMethodManager from "./components/PaymentMethodManager";
import ProfileDrawerHeader from "./components/ProfileDrawerHeader";
import AuditLogModal from "./components/AuditLogModal";

const TabPane = Tabs.TabPane;

const PaymentPanels = {
  paymentInfo: 'paymentInfo',
  programsAndMemberships: 'programsAndMemberships',
  giftcards: 'giftcards'
}

export default function ProfileDrawer({
  data,
  user,
  profileVisible,
  setProfileVisible,
  setShowEventDrawer,
  onSave,
}) {
  const [form] = Form.useForm();
  const [notesForm] = Form.useForm();
  const dispatch = useDispatch();
  const [paymentMethods, setPaymentMethods] = useState();
  const [customerWallets, setCustomerWallets] = useState({
    data: [],
    isLoading: true,
  });
  const [fetchingPaymentMethods, setFetchingPaymentMethods] = useState(false);
  const [showEmailSendModal, setShowEmailModal] = useState(false);

  const [giftCards, setGiftCards] = useState({
    data: [],
    isLoading: false,
  });

  const [loyaltyTransactions, setLoyaltyTransactions] = useState({
    data: [],
    isLoading: false,
  });

  const [shouldLoadPaymentMethods, setShouldLoadPaymentMethods] = useState(false);

  // O for Total Appointments
  // 1 for Upcoming Appointments
  // 2 for No Show Appointments
  const [showAppointments, setShowAppointments] = useState();

  // undefined or string
  const [showGoogleMap, setshowGoogleMap] = useState();
  const submitBtnRef = useRef();

  const {
    email: emailProp,
    phoneNumber: phoneNumberProp,
    primaryAddress: primaryAddressProp,
    dob: dobProp,
  } = user ?? {};

  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [showAuditLog, setShowAuditLog] = useState(false);

  const getCustomerPaymentMethodsLists = async (customerId) => {
    setFetchingPaymentMethods(true);
    dispatch(
      getCustomerPaymentMethods(customerId, (paymentMethods) => {
        setPaymentMethods(paymentMethods);
      })
    ).finally(() => {
      setFetchingPaymentMethods(false);
    });
  };

  const populateCustomerGiftCards = (customerId) => {
    setGiftCards((data) => ({ ...data, isLoading: true }));
    dispatch(getCustomerGiftCards(customerId))
      .then((res) => {
        if (res?.status === "success") {
          setGiftCards((data) => ({ data: res?.data ?? [], isLoading: false }));
        }
      })
      .finally(() => {
        setGiftCards((data) => ({ ...data, isLoading: false }));
      });
  };

  const populateCustomerLoyaltyTransactions = (customerId) => {
    if (customerId) {
      setLoyaltyTransactions((state) => ({ ...state, isLoading: true }));
      dispatch(getCustomerLoyaltyTransactions(customerId))
        .then((res) => {
          if (res?.status === "success") {
            setLoyaltyTransactions((state) => ({
              ...state,
              data: res?.data ?? [],
            }));
          }
        })
        .finally(() => {
          setLoyaltyTransactions((state) => ({ ...state, isLoading: false }));
        });
    }
  };

  const populateCustomerWallets = (customerId) => {
    if (customerId) {
      setCustomerWallets((state) => ({ ...state, isLoading: true }));
      dispatch(getCustomerWallets(customerId))
        .then((res) => {
          if (res?.status === "success") {
            setCustomerWallets((state) => ({ ...state, data: res?.data }));
          }
        })
        .finally(() => {
          setCustomerWallets((state) => ({ ...state, isLoading: false }));
        });
    }
  };

  useEffect(() => {
    if (profileVisible)
      form.setFieldsValue({
        phoneNumber: phoneNumberProp,
        email: emailProp,
        dob: dobProp ? moment(dobProp) : undefined,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.customerId, profileVisible]);

  useEffect(() => {
    if (profileVisible === false) {
      setShowAppointments();
      // dispatch(clearCustomerNotes());
      form.resetFields();
      // setCredits({
      //   data: 0,
      //   isLoading: false,
      // });
      setGiftCards({
        data: [],
        isLoading: false,
      });
      setCustomerWallets({
        data: [],
        isLoading: false,
      });
      setLoyaltyTransactions({
        data: [],
        isLoading: false,
      });
      setPaymentMethods()
      setShouldLoadPaymentMethods(false)
      setFetchingPaymentMethods(false)
      setShowAuditLog(false)
    } else if (user?.customerId) {
      // remove apis no more preloading
    }
  }, [profileVisible, user]);

  useEffect(() => {
    if (shouldLoadPaymentMethods && user?.customerId) {
      getCustomerPaymentMethodsLists(user?.customerId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldLoadPaymentMethods, user?.customerId])

  const paymentMethodId =
    paymentMethods?.find?.((paymentMethod) => paymentMethod?.isPrimary === true)
      ?.paymentMethodId ?? paymentMethods?.[0]?.paymentMethodId;

  return (
    <Drawer
      visible={profileVisible}
      width={"min(100vw, 580px)"}
      closable={false}
      destroyOnClose
      headerStyle={{ border: "none" }}
      className={styles.profileDrawer}
      onClose={() => {
        setProfileVisible(false);
        // setShowNoteForm(false);
      }}
      title={
        <ProfileDrawerHeader
          user={user}
          onBookingClick={() => {
            dispatch(setSelectedGuest(user));

            dispatch(
              setAppointmentDrawer({
                show: true,
                data: null,
              })
            );
            setProfileVisible(false);
          }}
          onClose={() => {
            setProfileVisible(false);
            // setShowNoteForm(false);
          }}
          showEmailSendModal={showEmailSendModal}
          setShowEmailModal={setShowEmailModal}
          refreshCustomer={onSave}
        />
      }
    >
      {showAppointments !== undefined && (
        <AppointmentsTab
          customerId={user?.customerId}
          status={showAppointments}
          onClose={() => setShowAppointments()}
          onSave={onSave}
        />
      )}

      <div
        className={`${styles.profileTabsContainer} ${showAppointments !== undefined ? styles.hidden : ""
          }`}
      >
        <Tabs
          className={styles.mainTab}
          tabBarExtraContent={{
            right: <div style={{ display: 'flex', gap: 16 }}>
              <AntdButton
                type="text"
                style={{ margin: 0, padding: 0 }}
                onClick={() => setShowAuditLog(true)}
              >
                Audit Log
              </AntdButton>
              {user?.isRegistrationComplete ? (
                <></>
              ) : (
                <AntdButton
                  type="text"
                  style={{ margin: 0, padding: 0 }}
                  onClick={() => dispatch(sendWelcomeEmail(user?.customerId))}
                >
                  Send Welcome Email
                </AntdButton>
              )}
            </div>,
          }}
        >
          <TabPane tab="Profile" style={{ fontSize: 18, fontWeight: "bold" }}>
            {/* Upcoming and History Appointments Start */}
            <CustomerBookingCounts
              customer={user}
              customerId={user?.customerId}
              onAppointmentTypeClick={(status) => setShowAppointments(status)}
            />
            {/* Upcoming and History Appointments End */}
            <Form
              form={form}
              layout="vertical"
              requiredMark={false}
              onFinishFailed={({ values, errorFields, outOfDate }) => {
                form.scrollToField(errorFields[0].name, {
                  scrollMode: "if-needed",
                  block: "center",
                  behavior: "smooth",
                });
              }}
              onFinish={(values) => {
                values.guestId = user?.customerId;
                values.address = primaryAddressProp;
                if (values.dob) {
                  values.dob = values.dob
                    ? moment(values.dob).toISOString()
                    : undefined;
                } else {
                  values.dob = user?.dob;
                }
                dispatch(updateGuest(values)).then((res) => {
                  if (res?.status === "success") onSave?.();
                });
              }}
            >
              <FormPhoneNumber
                formItemClassName="label-d-none "
                variant="underlined"
                name="phoneNumber"
                label=""
                placeholder="Mobile Number"
                required={true}
                formItemStyles={{ marginBottom: 12 }}
              />
              <FormInput
                formItemClassName="label-d-none "
                variant="underlined"
                name="email"
                label=""
                type="email"
                placeholder="Email Address"
                formItemStyles={{ marginBottom: 12 }}
                required={true}
                addonBefore={
                  <MailOutlined
                    style={{
                      fontSize: 17,
                    }}
                  />
                }
                addonAfter={
                  <AntdButton
                    type="text"
                    onClick={() => {
                      setShowEmailModal(true);
                    }}
                    style={{ paddingRight: 0 }}
                  >
                    Send Email
                  </AntdButton>
                }
              />
              <Collapse
                expandIconPosition={"end"}
                style={{
                  background: "#fff",
                  border: "none",
                  boxShadow: "none",
                }}
              >
                <Collapse.Panel
                  key="addressesInfo"
                  style={{ background: "#fff", boxShadow: "none" }}
                  header={
                    <p
                      style={{
                        margin: 0,
                        fontSize: 20,
                        fontFamily: "tradeGothic",
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      Addresses Information
                    </p>
                  }
                >
                  <AddressesInformation customerId={user?.customerId} />
                </Collapse.Panel>
              </Collapse>

              <FormHiddenSubmitButton submitRef={submitBtnRef} />

              <Collapse
                defaultActiveKey={"otherInfo"}
                expandIconPosition={"end"}
                style={{
                  background: "#fff",
                  border: "none",
                  boxShadow: "none",
                }}
              >
                <Collapse.Panel
                  key="otherInfo"
                  style={{ background: "#fff", boxShadow: "none" }}
                  header={
                    <div
                      style={{ display: "flex", gap: 8, alignItems: "center" }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontSize: 20,
                          fontFamily: "tradeGothic",
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        Other Information
                      </p>
                      {user && !user.dob && (
                        <ExclamationCircleOutlined
                          style={{ color: "#f5222d", fontSize: 17 }}
                        />
                      )}
                    </div>
                  }
                >
                  <div>
                    <FormDatePicker
                      form={form}
                      name="dob"
                      label="Date of Birth"
                      variant="underlined"
                      formItemStyles={{ marginBottom: 0 }}
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                      disabledDate={(current) =>
                        current.isSameOrAfter(
                          moment().set({
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0,
                          })
                        )
                      }
                    />
                  </div>
                </Collapse.Panel>
              </Collapse>
            </Form>
            <Collapse
              expandIconPosition={"end"}
              style={{
                background: "#fff",
                border: "none",
                boxShadow: "none",
              }}
              onChange={(panels) => {
                if (panels?.includes?.(PaymentPanels.paymentInfo)) {
                  setShouldLoadPaymentMethods(true)
                }
              }}
            >
              <Collapse.Panel
                key={PaymentPanels.paymentInfo}
                style={{ background: "#fff", boxShadow: "none" }}
                header={
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      fontFamily: "tradeGothic",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    Payment Information
                  </p>
                }
              >
                <Row>
                  <Col xs={24}>
                    <PaymentMethodManager
                      customerId={user?.customerId}
                      paymentMethods={paymentMethods}
                      fetchingPaymentMethods={fetchingPaymentMethods}
                      refetchPaymentMethods={() => {
                        getCustomerPaymentMethodsLists(user?.customerId);
                      }}
                    // onLoad={() => {
                    //   getCustomerPaymentMethodsLists(user?.customerId);
                    // }}
                    />
                  </Col>
                </Row>
              </Collapse.Panel>
            </Collapse>

            <Collapse
              expandIconPosition={"end"}
              style={{
                background: "#fff",
                border: "none",
                boxShadow: "none",
              }}
              onChange={(panels) => {
                if (panels?.includes?.(PaymentPanels.programsAndMemberships)
                  || panels?.includes?.(PaymentPanels.giftcards)
                ) {
                  setShouldLoadPaymentMethods(true)
                }
              }}
            >
              <Collapse.Panel
                key="intakeForms"
                style={{ background: "#fff", boxShadow: "none" }}
                header={
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      fontFamily: "tradeGothic",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    Intake Forms
                  </p>
                }
              >
                <Row>
                  <Col xs={24}>
                    <IntakeForms
                      user={user}
                      variant="full"
                      refreshCustomer={onSave}
                    />
                  </Col>
                </Row>
              </Collapse.Panel>
              <Collapse.Panel
                key="notes"
                style={{ background: "#fff", boxShadow: "none" }}
                header={
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      fontFamily: "tradeGothic",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    Notes
                  </p>
                }
              >
                <NotesGrid customerId={user?.customerId} form={notesForm} />
              </Collapse.Panel>
              <Collapse.Panel
                key="programsAndMemberships"
                style={{ background: "#fff", boxShadow: "none" }}
                header={
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      fontFamily: "tradeGothic",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    Programs and Memberships
                  </p>
                }
              >
                <ProgramsList
                  customerId={user?.customerId}
                  paymentMethodId={paymentMethodId}
                />
              </Collapse.Panel>
              <Collapse.Panel
                key="giftcards"
                style={{ background: "#fff", boxShadow: "none" }}
                header={
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      fontFamily: "tradeGothic",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    Gift Cards
                  </p>
                }
              >
                <GiftCardRow
                  view="concise"
                  // credit={credit?.data ?? 0}
                  // isCreditLoading={credit?.isLoading}
                  paymentMethod={
                    paymentMethods?.find?.(
                      (paymentMethod) => paymentMethod?.isPrimary === true
                    ) ??
                    paymentMethods?.[0] ??
                    null
                  }
                  customer={user}
                  customerId={user?.customerId}
                  loading={giftCards.isLoading}
                  onLoad={() => {
                    populateCustomerGiftCards(user?.customerId);
                    populateCustomerWallets(user?.customerId);

                  }}
                  giftCards={giftCards.data ?? []}
                  refetchGiftCards={() => { }}
                  refreshGiftCards={() =>
                    populateCustomerGiftCards(user?.customerId)
                  }
                  refreshCredits={() => {
                    // populateWalletCredits(user?.customerId);
                    populateCustomerWallets(user?.customerId);
                  }}
                  isCustomerWalletsLoading={customerWallets?.isLoading}
                  customerWallets={customerWallets?.data}
                />
              </Collapse.Panel>
              <Collapse.Panel
                key="loyaltyPoints"
                style={{ background: "#fff", boxShadow: "none" }}
                header={
                  <p
                    style={{
                      margin: 0,
                      fontSize: 20,
                      fontFamily: "tradeGothic",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    Reward Points
                  </p>
                }
              >
                <LoyaltyPointsList
                  loading={loyaltyTransactions.isLoading}
                  transactions={loyaltyTransactions.data ?? []}
                  availableLoyaltyPoints={user?.availableLoyaltyPoints}
                  onLoad={() => {
                    populateCustomerLoyaltyTransactions(user?.customerId);
                    // The points balance lives on the guest, not on the
                    // transaction history response.
                    onSave?.();
                  }}
                />
              </Collapse.Panel>
            </Collapse>
            <Button
              style={{
                height: 50,
                width: 120,
                borderRadius: 30,
                marginTop: 30,
              }}
              onClick={() => {
                submitBtnRef?.current?.click();
              }}
            >
              Save
            </Button>
          </TabPane>
          <TabPane
            tab="Charts"
            key={2}
            style={{ fontSize: 18, fontWeight: "bold", paddingTop: 16 }}
          >
            <ChartsTab user={user} />
          </TabPane>
          <TabPane
            tab="Files"
            key={3}
            style={{ fontSize: 18, fontWeight: "bold", paddingTop: 16 }}
          >
            <FilesTab user={user} />
          </TabPane>
          {/* <TabPane
            tab="Audit Log"
            key={4}
            style={{ fontSize: 18, fontWeight: "bold", paddingTop: 16 }}
          >
            <AuditLog />
          </TabPane> */}

        </Tabs>
      </div>
      <AuditLogModal
        visible={showAuditLog}
        onClose={() => setShowAuditLog(false)}
        customerId={user?.customerId}
        userId={user?.userId}
        customerName={user?.firstName + " " + user?.lastName}
      />
    </Drawer>
  );
}
